import React from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import type { AlertColor } from '@mui/material/Alert'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'
import RichText from '@/components/RichText'

type BannerBlockProps = {
  style?: 'info' | 'warning' | 'error' | 'success'
  content: DefaultTypedEditorState
}

type Props = {
  className?: string
  blockName?:string
} & BannerBlockProps

export const BannerBlock: React.FC<Props> = ({ className, content, style }) => {
  const severity: AlertColor = (style === 'error' || style === 'warning' || style === 'success' || style === 'info')
    ? style
    : 'info'

  return (
    <Box
      
      sx={{
        mx: 'auto',
        my: 2,
        width: '100%',
      }}
      className={className}
    >
      <Alert
        severity={severity}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: 1,
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <RichText data={content} enableGutter={false} enableProse={false} />
      </Alert>
    </Box>
  )
}
